import { useEffect } from 'react'

function lockScrolling() {
  if (document && document.body && document.body.style) {
    document.body.style.top = `-${window.scrollY}px`
    document.body.style.position = 'fixed'
    document.body.style.width = '100vw'
    document.body.style.height = '100vh'
  }
}

function resumeScrolling() {
  if (document && document.body && document.body.style) {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    document.body.style.height = ''
    // eslint-disable-next-line radix
    window.scrollTo(0, parseInt(document.body.style.top || '0') * -1)
  }
}

export const useScrollLock = (): void => {
  useEffect(() => {
    lockScrolling()

    return () => {
      resumeScrolling()
    }
  }, [])
}
